import type { BreadcrumbItemType } from "antd/es/breadcrumb/Breadcrumb";
import { useIntl } from "react-intl";

import { visibleModules } from "../../modules";
import routes from "../../routes";
import { useCurrentUser } from "../basic/users";

export function useReportBreadcrumbs(currentBreadcrumb?: BreadcrumbItemType) {
  const intl = useIntl();

  const { user } = useCurrentUser();

  const reports = user ? visibleModules(user).reports : [];

  const breadcrumbs = [
    {
      path: routes.reports.index,
      breadcrumbName: intl.formatMessage({ id: "reports" }),
      children: reports
        .filter((r) => r.route !== routes.reports.index)
        .toSorted((a, b) =>
          intl.formatMessage(a.title).localeCompare(intl.formatMessage(b.title))
        )
        .map(({ route, title }) => ({
          path: route,
          breadcrumbName: intl.formatMessage(title),
        })),
    },
  ] as BreadcrumbItemType[];

  if (currentBreadcrumb) breadcrumbs.push(currentBreadcrumb);

  return breadcrumbs;
}
